module.exports = __webpack_public_path__ + "static/media/ten.d3c61021.png";